import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import ddt from '@wix/da-ddt';
import { toJsonString, isSSR } from '../utils';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { mergeEventDataWithContext } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { ADUNIT_MAP, FREESTAR_PREFIX } from '../constants';
class Freestar {
    logBi(eventData) {
        // Limit units to 2 logs max
        const loggedId = `${eventData.unitId}${eventData.evid}`;
        if (this.biLogged[loggedId] >= 2) {
            ddt.log('ads', 'Skip BI at limit', loggedId);
            return;
        }
        var _this_biLogged_loggedId;
        this.biLogged[loggedId] = ((_this_biLogged_loggedId = this.biLogged[loggedId]) !== null && _this_biLogged_loggedId !== void 0 ? _this_biLogged_loggedId : 0) + 1;
        if (!this.biContext) {
            this.logQueue.push(eventData);
            return;
        }
        biLogger.log(this.publicSession, mergeEventDataWithContext(eventData, this.biContext), false);
        this.flushBiQueue();
    }
    flushBiQueue() {
        if (this.logQueue.length > 0) {
            for (const item of this.logQueue){
                biLogger.log(this.publicSession, mergeEventDataWithContext(item, this.biContext), false);
            }
            this.logQueue = [];
        }
    }
    init() {
        if (!isSSR()) {
            try {
                var _window_googletag;
                // Replay events that happen before react lives
                if (window.__DAADS__ && Array.isArray(window.__DAADS__.ev)) {
                    for (const storedEvt of window.__DAADS__.ev){
                        ddt.log('ads', `gak boot evt ${storedEvt.ev}`, storedEvt === null || storedEvt === void 0 ? void 0 : storedEvt.e);
                        if (storedEvt.ev === 'slotRenderEnd') {
                            this.logBi(BiData(_object_spread({
                                evid: 8802,
                                unsafe: BiContextProvidedValue,
                                itemid: BiContextProvidedValue,
                                typeid: BiContextProvidedValue
                            }, this.biDataFromEvent(storedEvt.e))));
                        }
                    }
                    window.__DAADS__.ev = false;
                }
                // Listen for new events
                window['googletag'] = window['googletag'] || {
                    cmd: []
                };
                (_window_googletag = window['googletag']) === null || _window_googletag === void 0 ? void 0 : _window_googletag.cmd.push(()=>{
                    window['googletag'].pubads().addEventListener('slotRenderEnded', (e)=>{
                        this.logBi(BiData(_object_spread({
                            evid: 8802,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue
                        }, this.biDataFromEvent(e))));
                    });
                });
                window.addEventListener('pagehide', ()=>{
                    this.flushBiQueue();
                });
            } catch (e) {
                ddt.alertOnError(e, 'ads', 'Fatal in ads BI', [
                    'ads'
                ], e.message);
            }
        }
    }
    registerUnit(unitId, options, safety) {
        if (safety === 'off') {
            ddt.log('ads', 'Skipped register because ads are OFF', unitId);
            return;
        }
        if (!isSSR()) {
            ddt.log('ads', 'register freestar client ad', unitId);
            window['freestar'].queue.push(function() {
                if (unitId === `${FREESTAR_PREFIX}${ADUNIT_MAP['AdhesionGam']}`) {
                    window['freestar'].newStickyFooter(unitId);
                    return;
                }
                window['freestar'].newAdSlots([
                    _object_spread({
                        placementName: unitId,
                        slotId: unitId
                    }, options)
                ]);
            });
        } else {
            ddt.log('ads', 'register freestar ssr ad', unitId);
            this.ssrUnits[unitId] = options;
        }
    }
    killUnit(unitId) {
        window['freestar'].queue.push(function() {
            if (unitId === `${FREESTAR_PREFIX}${ADUNIT_MAP['AdhesionGam']}`) {
                window['freestar'].deleteStickyFooter(unitId);
                return;
            }
            window['freestar'].deleteAdSlots(unitId);
        });
    }
    toSSR() {
        const units = [];
        let adhesion = '';
        const targetingItems = [];
        for (const _ref of Object.keys(this.ssrUnits)){
            var key = _ref;
            const _this_ssrUnits_key = this.ssrUnits[key], { targeting  } = _this_ssrUnits_key, options = _object_without_properties(_this_ssrUnits_key, [
                "targeting"
            ]);
            targetingItems.push({
                [key]: targeting
            });
            if (key === `${FREESTAR_PREFIX}${ADUNIT_MAP['AdhesionGam']}`) {
                adhesion = `freestar.newStickyFooter("${FREESTAR_PREFIX}${ADUNIT_MAP['AdhesionGam']}");`;
                continue;
            }
            units.push(_object_spread({
                placementName: key,
                slotId: key
            }, options));
        }
        // https://help.freestar.com/help/event-based-implementation
        const slots = `window['freestar'].newAdSlots(JSON.parse(${toJsonString(units)}));`;
        // https://help.freestar.com/help/using-key-values
        const target = `window['freestar'].config.targeting = JSON.parse(${toJsonString(targetingItems)});`;
        return `window['freestar'].queue.push(function () {${target}${slots}${adhesion}});`;
    }
    setBiContext(context, session) {
        this.biContext = context;
        this.publicSession = session;
    }
    biDataFromEvent(e) {
        const { advertiserId , campaignId , companyIds , creativeId , creativeTemplateId , lineItemId , yieldGroupIds , isEmpty , size  } = e;
        const keys = e.slot.getTargetingKeys();
        const tMap = {};
        for (const key of keys){
            tMap[key] = e.slot.getTargeting(key).join('|');
        }
        const data = _object_spread({
            unitId: e.slot.getSlotElementId(),
            isEmpty,
            size: Array.isArray(size) ? size.join(',') : '',
            advertiserId,
            campaignId,
            companyIds: Array.isArray(companyIds) ? companyIds.join(',') : '',
            creativeId,
            creativeTemplateId,
            lineItemId,
            yieldGroupIds: Array.isArray(yieldGroupIds) ? yieldGroupIds.join(',') : ''
        }, tMap);
        return data;
    }
    constructor(){
        this.ssrUnits = {};
        this.logQueue = [];
        this.biLogged = {};
    }
}
export default Freestar;
